<div class="flex justify-between">
    <button
        mat-button
        (click)="getOrders(OrderType.ACTUAL)"
        [ngClass]="{'active': orderType === OrderType.ACTUAL}"
        [disabled]="loading"
        data-testid="actual-orders-button"
    >Актуальные</button>
    <button
        mat-button
        (click)="getOrders(OrderType.ACTIVE)"
        [ngClass]="{'active': orderType === OrderType.ACTIVE}"
        [disabled]="loading"
    >Нераспределенные</button>
    <button
        mat-button
        (click)="getOrders(OrderType.INACTIVE)"
        [ngClass]="{'active': orderType === OrderType.INACTIVE}"
        [disabled]="loading"
        data-testid="inactive-orders-button"
    >Неактуальные</button>
</div>
<h5>Заявки:</h5>
@if (orderType === OrderType.ACTIVE) {
    <div class="flex-column">
        <div class="flex a-center">
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Начало периода</mat-label>
                <input matInput [formControl]="timeControl" type="time" placeholder="Введите время">
                <button matSuffix mat-icon-button (click)="timeControl.reset()">
                    <mat-icon>backspace</mat-icon>
                </button>
            </mat-form-field>
        </div>
        <div class="flex a-center">
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Адрес</mat-label>
                <input matInput [formControl]="addressControl" placeholder='Введите адрес'>
                <button matSuffix mat-icon-button (click)="addressControl.reset()">
                    <mat-icon>backspace</mat-icon>
                </button>
            </mat-form-field>
        </div>
    </div>
}

@if (loading) {
    <div class="w-100 flex j-center">
        <mat-spinner [diameter]="20" data-testid="loading-order-list-spinner"></mat-spinner>
    </div>
} @else {
    <div class="flex-column">
        @for (order of orders; track order) {
            @if (orderType === OrderType.ACTIVE) {
                <div class="p-relative mrb-1">
                    <app-task-card [task]="order" [executorList]="true"/>
                    <button type="button" class="p-absolute right-0 top-0" mat-button (click)="assignOrderToMe($event, order)">
                        <span>Взять в работу</span>
                        <mat-icon>assignment_ind</mat-icon>
                    </button>
                </div>
            } @else {
                <div class="p-relative mrb-1" (click)="openOrderForm(order.data.id)">
                    <app-task-card [task]="order" [executorList]="true" data-testid="task-card-executor-div"/>
                    <button type="button" class="p-absolute right-0 top-0" mat-icon-button (click)="openYandexMaps($event, order.data.location.latitude, order.data.location.longitude)">
                        <mat-icon>assistant_navigation</mat-icon>
                    </button>
                </div>
            }
        }

        @if (!orders.length) {
            нет заявок
        }
    </div>
}
